import store from "@/store";
import httpService from "./http-service";
import endpoints from "../utilities/endpoints";
import notificationsUtility from "@/utilities/notifications-utility";

export default {
  login(payload) {
    return httpService.post(endpoints.auth.login, payload).then((response) => {
      if (
        response.data.token &&
        response.data.user.groups_id.includes(1) // check for internal user group id
      ) {
        store.commit("auth/SET_USER", response.data.user);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        notificationsUtility.pushNotification({
          message: "Logged in successfully",
          type: "success",
        });
        setTimeout(() => window.location.replace("/"), 2000);
      } else {
        notificationsUtility.pushNotification({
          message: "Unauthorized",
          type: "error",
        });
      }
    });
  },

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    store.commit("auth/SET_USER", null);
    window.location.replace("/login");
  },
  getUser() {
    return httpService.get("admin/user-info").then((response) => {
      if (response.data) {
        store.commit("auth/SET_USER", response.data);
        localStorage.setItem("user", JSON.stringify(response.data));
      }
    });
  },
  forgotPassword(payload) {
    return httpService.post(endpoints.auth.forgotPassword, payload);
  },
  resetPassword(payload) {
    return httpService.post(endpoints.auth.resetPassword, payload);
  },
  updateProfile(uuid, payload) {
    return httpService.put("profile/" + uuid, payload);
  },
};
